<template>
  <div v-show="requestCount > 0" class="telegram-bot-adduser--container">
    <div v-if="!status" class="status-false">
      <div>
        Для того, чтобы данный доп.аккаунт смог принимать уведомления от Telegram-бота,
        необходимо, чтобы доп.аккаунт отправил боту
        <span class="text-orange text-bold">@EnrollerBot</span> кодовое сообщение:
      </div>

      <div class="mrg-t-20">Скопируйте код для бота</div>

      <div class="tg-bot--code-and-copy-container">
        <div class="line-1">

          <div class="code">
            <div class="input-block">
              <input :value="bot_command">
            </div>
          </div>

          <div class="copy">
            <div @click="copyText(bot_command)" class="btn btn-sm btn-orange">Скопировать </div>
          </div>
        </div>

        <div class="line-2">
          <a
            href="https://t.me/EnrollerBot"
            class="btn btn-sm btn-info mrg-l-0 d-block"
            target="_blank"
          >
            Перейти к Telegram-боту
          </a>
        </div>
      </div>

      <div class="time-notification mrg-t-30">
        <div class="left">
          <f-awesome icon="hourglass"></f-awesome>
        </div>
        <div class="right">
          Обратите внимание, что данная команда доступна в течение 25 минут. Далее регистрационный токен
          станет недействительным и необходимо будет снова открыть данное окно, чтобы получить новый
        </div>
      </div>


      <div class="exclamation mrg-t-30">
        <div class="left">
          <f-awesome icon="exclamation"></f-awesome>
        </div>
        <div class="right">
          Не забудьте разрешить уведомления для доп.аккаунтов в разделе "Настройки" -> "Уведомления"
        </div>
      </div>

    </div>

    <div v-if="status" class="status-true">

      <div>
        <b>Сотрудник привязан к боту и может получать уведомления!</b>
      </div>

      <div class="exclamation mrg-t-30">
        <div class="left">
          <f-awesome icon="exclamation"></f-awesome>
        </div>
        <div class="right">
          Вы можете отвязать его нажатием на кнопку, уведомления больше
          приходить не будут. Сделать повторную привязку можно будет в любой момент
        </div>
      </div>

      <div class="mrg-t-30">
        <div @click="exitTelegram" class="btn btn-sm btn-danger d-block">Отвязать</div>
      </div>

    </div>
  </div>
</template>

<script>

import adduserRepository from "../../../repositories/adduser";

export default {
  name: "TelegramBotAdduser",
  components: {},
  data() {
    return {
      status: false,
      requestCount: 0,
      bot_command: ''
    };
  },
  props: {
    show: Boolean,
    staffId: Number
  },
  watch: {
    show: function(val){
      if(val){
        this.getData();
      }else{
        this.requestCount = 0;
      }
    }
  },
  computed: {

  },
  methods: {
    copyText(text){
      navigator.clipboard.writeText(text)
          .then(() => {
            this.$store.dispatch("addNotification", {
              text: 'Текст скопирован в буфер обмена',
              time: 3,
              color: "success"
            });
          })
          .catch(() => {
            this.$store.dispatch("addNotification", {
              text: 'Ваш браузер не поддерживает копирование',
              time: 3,
              color: "danger"
            });
          });
    },
    getData(){
      this.$store.dispatch("startPreloader");

      adduserRepository.telegram({id: this.staffId}).then(resp => {
        this.requestCount++;
        this.status = resp.data.telegram_status;
        if(!this.status){
          this.bot_command = resp.data.bot_command;
        }
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    exitTelegram(){
      this.$store.dispatch("startPreloader");

      adduserRepository.telegramExit({id: this.staffId}).then(() => {
        this.$store.dispatch("addNotification", {
          text: 'Отвязка произошла успешно',
          time: 3,
          color: "success"
        });
        this.$store.dispatch("stopPreloader");
        this.$emit('exit');
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    }
  }
};
</script>

<style scoped lang="less">
.tg-bot--code-and-copy-container{
  width: 80%;
  .line-1{
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    flex-direction: row;

    .code{
      width: 65%;
    }
    .copy{
      width: 30%;
    }
  }
}
.time-notification{
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  flex-direction: row;

  .left{
    color: #ebc351;
    text-align: center;
    font-size: 28px;
    width: 10%;
  }

  .right{
    width: 87%;
  }
}

.exclamation{
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  flex-direction: row;

  .left{
    color: #ebc351;
    text-align: center;
    font-size: 28px;
    width: 10%;
  }

  .right{
    width: 87%;
  }
}

@media (max-width: 480px) {
  .tg-bot--code-and-copy-container{
    width: 100%;
    }
}
</style>
